import { Outlet, Link } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import Logo from '../components/Logo'
import ThemeToggle from '../components/ThemeToggle'
import UserMenu from '../components/auth/UserMenu'
import { StorageInitializer } from '../components/StorageInitializer'

export default function Layout() {
  const { user, currentCompany } = useAuth()

  return (
    <StorageInitializer>
      <div className="min-h-screen page-bg">
        {/* Navigation */}
        <div className="border-b nav-bg">
          <nav className="container mx-auto py-4 flex items-center justify-between">
            <Link to="/">
              <Logo />
            </Link>
            <div className="flex items-center gap-2">
              {user && (
                <>
                  <Link to="/videos" className="btn-ghost px-3 py-2 rounded-xl text-sm">
                    Vídeos
                  </Link>
                  <Link to="/storage-test" className="btn-ghost px-3 py-2 rounded-xl text-sm">
                    Test
                  </Link>
                  {currentCompany && (
                    <Link to="/novo" className="btn-ghost px-3 py-2 rounded-xl text-sm">
                      Novo
                    </Link>
                  )}
                </>
              )}
              <ThemeToggle />
              {user ? (
                <UserMenu />
              ) : (
                <div className="flex items-center gap-2">
                  <Link to="/login" className="btn-ghost px-3 py-2 rounded-xl text-sm">
                    Entrar
                  </Link>
                  <Link to="/signup" className="btn-primary px-3 py-2 rounded-xl text-sm">
                    Cadastrar
                  </Link>
                </div>
              )}
            </div>
          </nav>
        </div>
        
        {/* Main Content */}
        <main>
          <Outlet />
        </main>
      </div>
    </StorageInitializer>
  )
}
